import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DialogService } from '../../utility/dialog/dialog-service';
import { LoginService } from '../../../services/login-service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HttpService } from '../../utility/http-service';
import { ScheduleFilters } from '../schedules/model';
import { FracXPreferences } from '../../utility/utilities';
import { RouterService } from '../../utility/router-service';

@Component({
  selector: 'app-user-settings',
  standalone: false,
  
  templateUrl: './user-settings.component.html',
  styleUrl: './user-settings.component.css'
})
export class UserSettingsComponent implements OnInit  {

  wdxUser?: string;
  wdxPassword?: string;
  editForm: FormGroup;
  filters: ScheduleFilters = { operators: [], regions: [], stateCounty: [] };
  userPreferences?: FracXPreferences;

  ngOnInit() {
    this.http.get("FracX/FilterValues", (filters: ScheduleFilters) => {
      this.filters = filters;
      this.filters.regions.shift();
    });

    this.http.get("FracX/GetUserPreferences", (prefs: FracXPreferences) => {
      this.userPreferences = prefs;

      const props: any = {
        "enableFracXNotifications": new FormControl(this.userPreferences.enableNotifications, []),
        "allRegions": new FormControl(this.userPreferences.allRegions, []),
        "enableDaysFilter": new FormControl(this.userPreferences.daysOut, []),
        "followedRegions": new FormControl(this.userPreferences.subscribedRegions, []),
        "fracXDaysOut": new FormControl(this.userPreferences.daysOut, [])
      };
      this.editForm = this.formBuilder.group(props);
    })

  }

  onSubmit(): void {
    if (this.editForm?.value) {
      let prefs: FracXPreferences = {
        allRegions: this.editForm.value.allRegions,
        enableNotifications: this.editForm.value.enableFracXNotifications,
        subscribedRegions: this.editForm.value.allRegions ? [] : this.editForm.value.followedRegions,
        daysOut: this.editForm.value.enableDaysFilter ? this.editForm.value.fracXDaysOut : null
      };
      this.http.post("FracX/UpdateUserPreferences", () => { this.router.reloadPage() }, prefs);
    }
  }

  constructor(public dialogService: DialogService,
    public formBuilder: FormBuilder,
    public loginService: LoginService,
    public router: RouterService,
    private http: HttpService) {
    const props: any = {
      "enableFracXNotifications": new FormControl(this.userPreferences?.enableNotifications, []),
      "allRegions": new FormControl(this.userPreferences?.allRegions, []),
      "enableDaysFilter": new FormControl(this.userPreferences?.daysOut, []),
      "followedRegions": new FormControl(this.userPreferences?.subscribedRegions, []),
      "fracXDaysOut": new FormControl(this.userPreferences?.daysOut, [])
    };
    this.editForm = this.formBuilder.group(props);
  }

  loginWdx() {
    if (!this.wdxUser || this.wdxUser.trim().length == 0)
      this.dialogService.showError('You must enter a user name to login to WDX');
    if (!this.wdxPassword || this.wdxPassword.trim().length == 0)
      this.dialogService.showError('You must enter a user name to login to WDX');

    var formData = new FormData();
    formData.append('user', this.wdxUser ?? "");
    formData.append('pass', this.wdxPassword ?? "");

    this.http.post("User/LoginWDX", () => this.router.reloadPage(), null, formData);
  }

  logoutWdx() {
    this.http.post("User/LogoutWDX", () => this.router.reloadPage(), null, null);
  }

}
